import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import schoolService from "./schoolService";

export const getSchools = createAsyncThunk(
  "school/get-schools",
  async (thunkAPI) => {
    try {
      return await schoolService.getSchools();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getaSchool = createAsyncThunk(
  "school/get-schools",
  async (id, thunkAPI) => {
    try {
      return await schoolService.getaSchool(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getSchoolVisitData = createAsyncThunk(
  "school/get-schoolsVisit",
  async (id, thunkAPI) => {
    try {
      return await schoolService.getSchoolVisitData(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createSchool = createAsyncThunk(
  "school/create-schools",
  async (userData, { rejectWithValue }) => {
    try {
      return await schoolService.createSchool(userData);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.message;
        return rejectWithValue(errorMessage);
      } else {
        const errorMessage = "Something Went Wrong!";
        return rejectWithValue(errorMessage);
      }
    }
  }
);
export const getSchoolVisitList = createAsyncThunk(
  "schoolvisit/get-schoolvisit",
  async (thunkAPI) => {
    try {
      return await schoolService.getSchoolVisitList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// new
export const getSchoolVisitTarget = createAsyncThunk(
  "schoolvisittarget/get-schoolvisittarget",
  async (thunkAPI) => {
    try {
      return await schoolService.getSchoolVisitTarget();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSchoolVisitStatus = createAsyncThunk(
  "schoolvisitstatus/get-schoolvisitstatus",
  async (thunkAPI) => {
    try {
      return await schoolService.getSchoolVisitStatus();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  schools: [],
  schoolvisits: [],
  schoolvisitstatus: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  errorMessage: "",
};

export const schoolSlice = createSlice({
  name: "school",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSchools.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchools.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schools = action.payload;
      })
      .addCase(getSchools.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;
      })
      .addCase(getSchoolVisitData.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.message = "";
      })
      .addCase(getSchoolVisitData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.schoolVisits = action.payload;
      })
      .addCase(getSchoolVisitData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload || "Failed to fetch school visit data";
        state.schoolVisits = { visits: [] };
      })
      .addCase(createSchool.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSchool.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdschool = action.payload;
      })
      .addCase(createSchool.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.payload || action.error.message;
      })
      .addCase(getSchoolVisitList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchoolVisitList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schoolvisits = action.payload;
      })
      .addCase(getSchoolVisitList.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;
      })
      .addCase(getSchoolVisitTarget.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchoolVisitTarget.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schoolvisits = action.payload;
      })
      .addCase(getSchoolVisitTarget.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;
      })
      .addCase(getSchoolVisitStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSchoolVisitStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.schoolvisitstatus = action.payload;
      })
      .addCase(getSchoolVisitStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
        state.errorMessage = action.error.message;
      })
      .addCase(resetState, () => initialState);
  },
});

export default schoolSlice.reducer;
